import React, { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { EuiPageHeader, EuiPageHeaderSection, EuiTitle, EuiFlexGroup, EuiFlexItem, EuiSwitch, EuiText, EuiButtonIcon } from '@elastic/eui'
import { EuiSwitchEvent } from '@elastic/eui/src/components/form/switch/switch'

import { selectBlueprintEditMode, setEditMode } from '../aiPlanBlueprintSlice'

export interface AIPlanBlueprintHeaderProps {
  blueprintName: string
  companyName: string
  onEditNameClick?: () => void
}

const AIPlanBlueprintHeader: FC<AIPlanBlueprintHeaderProps> = ({ blueprintName, companyName, onEditNameClick }) => {
  const dispatch = useDispatch()
  const editMode = useSelector(selectBlueprintEditMode)

  const handleEditModeChange = (e: EuiSwitchEvent) => {
    dispatch(setEditMode(e.target.checked))
  }

  return (
    <EuiPageHeader>
      <EuiPageHeaderSection style={{ width: '100%' }}>
        <EuiFlexGroup direction='column' gutterSize='m'>
          <EuiFlexItem grow={false}>
            <EuiTitle size='m'>
              <h1>AI Blueprint: {companyName}</h1>
            </EuiTitle>
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
              <EuiFlexItem grow={false}>
                <EuiTitle size='s'>
                  <h2>{blueprintName}</h2>
                </EuiTitle>
              </EuiFlexItem>
              {editMode && onEditNameClick && (
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon iconType='pencil' style={{ color: '#0071c2' }} onClick={onEditNameClick} aria-label='Edit Name' />
                </EuiFlexItem>
              )}
              <EuiFlexItem />

              <EuiFlexItem grow={false}>
                <EuiFlexGroup gutterSize='s' alignItems='center'>
                  <EuiFlexItem grow={true}>
                    <EuiText size='s'>Edit Mode</EuiText>
                  </EuiFlexItem>
                  <EuiFlexItem grow={false}>
                    <EuiSwitch label='Edit Mode' showLabel={false} checked={editMode} onChange={handleEditModeChange} />
                  </EuiFlexItem>
                </EuiFlexGroup>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPageHeaderSection>
    </EuiPageHeader>
  )
}

export default AIPlanBlueprintHeader
